export const viewModelZinantisMemberDetail = {
    Id: true,
    Name: true,
    Address: true,
    Descriptions: {
        Id: true,
        Description: true,
        IdContentLanguage: true,
        ContentLanguage: {
            LocalizedCaption: true,
            Caption: true,
            Name: true,
            CultureId: true,
        },
    },
    IdLogoFile: true,
    LogoFile: {
        Id: true,
        VirtualPath: true,
    },
    IdCountry: true,
    Country: {
        Id: true,
        LocalizedCaption: true,
        Caption: true,
        Name: true,
        ISO2: true,
    },
    IdAccountManagementSegment: true,
    AccountManagementSegment: {
        Id: true,
        LocalizedCaption: true,
        Caption: true,
        Name: true,
    },
    WebSite: true,
    ZinantisMemberDate: true,
    BookingCodePrefix: true,
};
